// Enum for checklist status matching the backend enum

export const ChecklistStatus = {
    CLOSED: 0,
    OPEN: 1,
    NEW: 2
};